<footer class="footer">
    <div class="call-me">
        <div class="mail">
            <h6>mail:</h6>
            <p>heavyyrain3039@gmail.com</p>
        </div>
        <div class="phone">
            <h6>телефон:</h6>
            <p>+79094488311</p>
        </div>
    </div>
</footer>